import styled from 'styled-components';
import { getDashboardComponentTop, getDashboardComponentHeight, getDashboardComponentLeft, getDashboardComponentWidth, } from '../../Dashboard.utils';
export const Guide = styled.div `
    position: absolute;
    background-color: rgb(229, 229, 229);
    top: ${(props) => getDashboardComponentTop(props.top, props.rowHeight, props.gutter)}px;
    height: ${(props) => getDashboardComponentHeight(1, props.rowHeight, props.gutter)}px;
    left: ${(props) => getDashboardComponentLeft(props.left, props.columnCount, props.gutter)};
    width: ${(props) => getDashboardComponentWidth(1, props.columnCount, props.gutter)};
`;
//# sourceMappingURL=DashboardEditGuide.styled.js.map